import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { examinationModalStyle } from '@/components/modules/Modal/ExaminationModal/style';
import { Button } from '@/components/ui/Button/Button';
import { Modal } from '@/components/ui/Modal/Modal';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
/**
 * 審査中表示モーダル
 * @description 利用不可・仮登録等のユーザーに対して表示するモーダル
 */
export const ExaminationModal = (props) => {
    const { className = '', isShow } = props;
    const history = useNavigate();
    /**
     * 戻るボタンクリック時の処理
     * @description 前の画面に戻る
     */
    const onClickPrev = useCallback(() => {
        history.navigateTo(-1);
    }, [history]);
    const style = examinationModalStyle();
    return (_jsxs(Modal, Object.assign({ className: style.base({ class: className }), isShow: isShow, maxWidth: 'max-w-[590px]' }, { children: [_jsx("h2", Object.assign({ className: style.title() }, { children: "\u3054\u5229\u7528\u9802\u3044\u3066\u3044\u308B\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u73FE\u5728\u5BE9\u67FB\u4E2D\u3067\u3059\u3002" })), _jsxs("p", Object.assign({ className: style.text() }, { children: ["\u5BE9\u67FB\u306B\u95A2\u3059\u308B\u304A\u554F\u3044\u5408\u308F\u305B\u306F\u4E0B\u8A18\u307E\u3067\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002", _jsx("br", {}), "PROFFIT\u30B5\u30DD\u30FC\u30C8\u30C1\u30FC\u30E0\uFF1Asupport@proffit.jp"] })), _jsx(Button, Object.assign({ color: 'gray', onClick: onClickPrev, size: 'md' }, { children: "\u623B\u308B" }))] })));
};
